import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styles from "./Thankyoumail.module.scss";
import { API } from "aws-amplify";
import config from "../../../config/aws-exports";
import swal from "@sweetalert/with-react";
import { Constants } from "../../../config/Constants";
import { ReactComponent as Close } from "../../../assets/icons/close_black_24dp.svg";
import CircularProgress from "@mui/material/CircularProgress";
import BackDrop from "@mui/material/Backdrop";

const ThankyouMail = ({ open, onClose, selectedUsers, setSelectedUsers }) => {
  const [message, setMessage] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [spin, setSpin] = useState(false);
  //const [subject, setSubject] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    setErrorMessage("");
    setMessage("");

    const plainText = message.replace(/<[^>]+>/g, "").trim();

    if (!plainText) {
      setErrorMessage("Please Enter the Details");
      return;
    }

    sendMessage();
  };

  const handleClose = () => {
    onClose();
    setMessage("");
    setErrorMessage("");
  };

  async function sendMessage() {
    setSpin(true);
    var body = {
      oid: config.aws_org_id,
      schema: Constants.SCHEMA_NAME,
      userlist: selectedUsers,
      ntmsg: message,
    };

    const bodyParam = {
      body: body,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/sendThankyouMail",
        bodyParam,
      );
      setSpin(false);

      swal({
        title: "Success",
        text: "Mail sent successfully!",
        icon: "success",
        dangerMode: false,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
        }
      });
      setSelectedUsers([]);
      onClose();
    } catch (error) {
      console.error(error);
      setSpin(false);
      swal({
        title: "Oooops!",
        text: "Soomthing wrong!",
        icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
        }
      });
    }
  }

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [{ color: [] }, { background: [] }], // text and background color
      [{ align: [] }], // text alignment
    ],
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <BackDrop sx={{ color: "#fff" }} open={spin} className={styles.backdrop}>
        <CircularProgress color="inherit" />
      </BackDrop>
      <div
        style={{
          background: "#fff",
          width: "900px",
          padding: "20px",
          borderRadius: "6px",
          height: "600px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3>Thank You Mail</h3>

          <Close onClick={() => handleClose()} />
        </div>

        <div className={styles.editorWrapper}>
          <ReactQuill
            className={styles.customEditor}
            value={message}
            onChange={setMessage}
            modules={modules}
          />
        </div>

        <div style={{ color: "red" }}>{errorMessage}</div>

        <div
          style={{
            display: "flex",
            gap: "2rem",
            marginTop: "2rem",
            justifyContent: "center",
          }}
        >
          <button className={styles.submit} onClick={handleSubmit}>
            Submit
          </button>

          <button className={styles.cancel} onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankyouMail;
